import { render, staticRenderFns } from "./VoucherForm.vue?vue&type=template&id=04bfe47f&scoped=true"
import script from "./VoucherForm.vue?vue&type=script&lang=js"
export * from "./VoucherForm.vue?vue&type=script&lang=js"
import style0 from "./VoucherForm.vue?vue&type=style&index=0&id=04bfe47f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bfe47f",
  null
  
)

export default component.exports